import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/og";
import { CACHE, setEdgeCache } from "@/lib/http-cache";
import { SITE, ROBOTS_INDEX } from "@/lib/site";
import { Newsletter } from "@/components/newsletter";
import { OutputStrip } from "@/components/output-strip";
import { PageHeader } from "@/components/page-header";

export const Route = createFileRoute("/newsletter")({
  loader: async () => { await setEdgeCache(CACHE.page); },
  head: () => ({
    meta: [
        ...ogImageMeta(),
      { title: `Retail News Asia Newsletter - ${SITE.name}` },
      { name: "robots", content: ROBOTS_INDEX },
      { name: "description", content: `Subscribe free: Asian retail in your inbox every Monday, Wednesday and Friday — the stories, numbers and moves that matter.` },
      { property: "og:title", content: `Retail News Asia Newsletter - ${SITE.name}` },
      { property: "og:description", content: `Every Monday, Wednesday and Friday for retail decision-makers across Asia.` },
      { property: "og:url", content: `${SITE.url}/newsletter` },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: `Retail News Asia Newsletter - ${SITE.name}` },
      { name: "twitter:description", content: `Every Monday, Wednesday and Friday for retail decision-makers across Asia.` },
    ],
    links: [{ rel: "canonical", href: `${SITE.url}/newsletter` }],
  }),
  component: () => (
    <>
      <PageHeader
        eyebrow="Newsletter"
        title="The Retail News Asia newsletter."
        
        description={
          <p className="text-lg">
            Asia's retail industry, distilled for executives, brand owners and operators. Free.
            Monday, Wednesday and Friday editions, before 8am local time — the sharpest of the 125+
            articles we publish every week.
          </p>
        }
      />
      <OutputStrip />
      <Newsletter />

    </>
  ),
});
